export default {
  dashboard: 'Dashboard',
  titleCardAddPatient: 'ENTER PATIENT INFORMATION',
  edit: 'Edit',
  delete: 'Delete',
  home: 'Home',
  searchPatient: 'Search Patient',
  illnesses: 'Illnesses',
  AllowNegativeBalance: 'Allow Negative Balance',
  firstName: 'First Name',
  ENTERSSYMPTOMS: 'ENTER SYMPTOMS',
  Overview: 'Overview',
  NewPatients: 'New Patients',
  AdditionalPreviousExperiences: 'Additional Previous Experiences',
  ENTERALLOCATEDAMOUNT: 'Enter Allocated Amount',
  complaints: 'Complaints',
  AddAttandence: 'Add Attandence',
  Attandence: 'Attandence',
  attendanceDate: 'Attendance Date',
  accountManager: 'Account Manager',
  deleteAttandence: 'Delete Attandence',
  EditAttandence: 'Edit Attandence',
  draft: 'Draft',
  approved: 'Approved',
  numberOfEmployees: 'Number Of Employees',
  EditPayrollEntry: 'Edit Payroll Entry',
  rejected: 'Rejected',
  validateAttendance: 'Validate Attendance',
  EndDate: 'End Date',
  CreateSalarySlips: 'Create Salary Slips',
  SubmitSalarySlips: 'Submit Salary Slips',
  SubmitBankEntry: 'Submit Bank Entry',
  complaint: 'Complaint',
  HalfDay: 'Half Day',
  WorkFromHome: 'Work From Home',
  AddPayrollEntry: 'Add Payroll Entry',
  PayrollEntry: 'Payroll Entry',
  lateEntry: 'Late Entry',
  docstatus: 'Doc Status',
  Absent: 'Absent',
  Present: 'Present',
  OnLeave: 'On Leave',
  earlyExit: 'Early Exit',
  GetLinkedDocs: 'Get Linked Docs',
  isPaid: 'Is Paid',
  VoucherNo: 'Voucher No',
  allocatedAmount: 'Allocated Amount',
  carryForward: 'Add Unused Leave Balance ',
  unusedLeaves: 'Unused Leaves',
  allocatedAmountGreaterThanOutstanding:
    'Allocated Amount Greater Than Outstanding',
  AddComplaint: 'Add Complaint',
  Details: 'Details',
  symptom: 'Symptom',
  addSymptoms: 'Add Symptoms',
  ENTERCOMPLAINT: 'ENTER COMPLAINT',
  addLeaveApplication: 'Add Leave Application',
  editLeaveApplication: 'Edit Leave Application',
  AddHoliday: 'Add Holiday',
  HolidayList: 'Holiday List',
  DeleteHoliday: 'Delete Holiday',
  TotalHolidays: 'Total Holidays',
  EditHoliday: 'Edit Holiday',
  holidayListName: 'Holiday List Name',
  LeaveApplication: 'Leave Application',
  DeleteLeaveApplication: 'Delete Leave Application',
  halfDay: 'Half Day',
  symptoms: 'symptoms',
  totalLeaveDays: 'Total Leave Days',
  leaveBalance: 'Leave Balance',
  salaryDeduction: 'Salary Deduction',
  Week: 'Week',
  followViaEmail: 'Follow via Email',
  select_name: 'Select Name',
  Payment: 'Payment',
  totalLeavesAllocated: 'Total Leaves Allocated',
  totalLeavesEncashed: 'Total Leaves Encashed',
  carryForwardedLeavesCount: 'Carry Forwarded Leaves Count',
  patientID: 'ID',
  expired: 'Expired',
  leavePolicyAssign: 'Leave Policy Assignment',
  effectiveFrom: 'Effective From',
  effectiveTo: 'Effective To',
  leavesAllocated: 'Leaves Allocated',
  addLeavePolicyAssign: 'Add Leave Policy Assignment',
  GoodMorning: 'Good Morning',
  cancelPatientInsurancePolicy: 'Cancel Patient Insurance Policy',
  Yourscheduletoday: 'Your schedule today',
  isEarnedLeave: 'Is Earned Leave',
  DeleteLeavePolicy: 'Delete Leave Policy',
  annualAllocation: 'Annual Allocation',
  title: 'Title',
  typeName: 'Type Name',
  values: 'Values',
  typeCode: 'Type Code',
  primaryAddress: 'Primary Address',
  customAdditional: 'Custom Additional',
  EditLeaveAllocation: 'Edit Leave Allocation',
  DeleteLeaveType: 'Delete Leave Type',
  fractionOfDailyWagePerLeave: 'Fraction of Daily Wage per Leave',
  AddLeavePolicy: 'Add Leave Policy',
  Edit: 'Edit',
  EditLeavePolicy: 'Edit Leave Policy',
  leaveTypeName: 'Leave Name',
  leavePolicy: 'Leave Policy',
  EditLeaveType: 'Edit Leave Type',
  AddLeaveType: 'Add Leave Type',
  LeaveType: 'Leave Type',
  includeHoliday: 'Include Holiday',
  Partiallypaidleave: 'Partially Paid Leave',
  maxLeavesAllowed: 'Max Leaves Allowed',
  Areyouwithoutsalary: 'Unpaid Leave',
  maxContinuousDaysAllowed: 'Max Continuous Days Allowed',
  Isdeportationallowed: 'Is Deportation Allowed',
  applicableAfter: 'Applicable After',
  draft: 'Draft',
  cancelPayorContract: 'Cancel Company Contract',
  maximumCarryForwardedLeaves: 'Maximum Carry Forwarded Leaves',
  expireCarryForwardedLeavesAfterDays:
    'Expire Carry Forwarded Leaves After Days',
  Includedholidaysandvacations: 'Included holidays and vacations',
  AllowNegative: 'Allow Negative',
  Month: 'Month',
  Year: 'Year',
  Earnedleave: 'Earned Leave',
  Today: 'Today',
  submitted: 'Submitted',
  cancelled: 'Cancelled',
  settingHealthcare: 'Setting Healthcare',
  submitJournal: 'Submit Journal',
  cancelJournal: 'Cancel Journal',
  add: 'Add',
  cancel: 'Cancel',
  addAnAppointment: 'add an appointment',
  receiptVoucher: 'Receipt Voucher',
  custom_account: 'Account',
  addAnEncounter: 'add an encounter',
  AddStockEntry: 'Add Stock Entry',
  next: 'Next',
  details: 'Details',
  prev: 'Prev',
  salesDetails: 'Sales Details',
  payment: 'Payment',
  SaveDraft: 'Save Draft',
  inventoryDetails: 'Inventory Details',
  purchasing: 'Purchasing',
  salse: 'Sales',
  inventory: 'Inventory',
  accounts: 'Accounts',
  itemDefaults: 'Item Defaults',
  purchaseDetails: 'Purchase Details',
  returnPurchaseInvoice: 'Return Purchase Invoice',
  Save: 'Save',
  AcceptedQuantity: 'Accepted Quantity',
  RejectedQuantity: 'Rejected Quantity',
  SearchByDiagnosis: 'Search By Diagnosis',
  deletePayorContract: 'Delete Company Contract',
  AddPayorContract: 'Add Company Contract',
  costCenter: 'Cost Center',
  holidayDate: 'Holiday Date',
  weeklyOff: 'Weekly Off',
  debitNote: 'Debit Note',
  SaveSubmit: 'Save & Submit',
  exchangeRate: 'Exchange Rate',
  differenceAmount: 'Difference Amount',
  SearchPayorContract: 'Search Company Contract',
  settings: 'Settings',
  PayorContract: 'Company Contract',
  EditBNPI: 'Edit collection method',
  SearchPatientInsurancePolicy: 'Search Patient Insurance Policy',
  Inventory: 'Inventory',
  editDiagnosis: 'Edit Diagnosis',
  Last5Encounter: 'Last 5 Encounter',
  ItemPriceReport: 'Item Price Report',
  AddDiagnosis: 'Add Diagnosis',
  Last5Invoices: 'Last 5 Invoices',
  StatementOfAccount: 'Statement Of Account',
  AddStatementOfAccount: 'Add Statement Of Account',
  StockAnalysisReport: 'Stock Analysis Report',
  PurchaseAnalytics: 'Purchase Analytics',
  EditStatementOfAccount: 'Edit Statement Of Account',
  addStatementOfAccount: 'Add Statement Of Account',
  showRemarks: 'Show Remarks',
  accountReceivable: 'Accounts Receivable',
  accountPayable: 'Accounts Payable',
  ProfitLoss: 'Profit Loss',
  CustomerAddress: 'Customer Address',
  CashFlow: 'Cash Flow',
  topSuppliers: 'Top Suppliers',
  TopItemSold: 'Top Item Sold',
  TopItemPurchased: 'Top Item Purchased',
  BalanceSheet: 'Balance Sheet',
  ConsolidatedFinancialStatement: 'Consolidated Financial Statement',
  isStockItem: 'Is Stock Item',
  openingStock: 'Opening Stock',
  AccountPeriodInformation: 'Account Period Information',
  AccountPeriod: 'Account Period',
  periodName: 'Period Name',
  accountsReceivableSummary: 'Accounts Receivable Summary',
  closedDocuments: 'Closed Documents',
  grossProfit: 'Gross Profit',
  AddAccountPeriod: 'Add Account Period',
  enableDeferredRevenue: 'Enable Deferred Revenue',
  valuationRate: 'Valuation Rate',
  standardRate: 'Standard Rate',
  isFixedAsset: 'Is Fixed Asset',
  serviceEndDate: 'Service End Date',
  autoCreateAssets: 'Auto Create Assets',
  deferredRevenueAccount: 'Deferred Revenue Account',
  isGroupedAsset: 'Is Grouped Asset',
  serviceStartDate: 'Service Start Date',
  zeroRated: 'Zero Rated',
  isExempt: 'Is Exempt',
  is_exempt: 'Is Exempt',
  exempt: 'Exempt',
  salesUom: 'Sales UOM',
  isSalesItem: 'Is Sales Item',
  maxDiscount: 'Max Discount',
  grantCommission: 'Grant Commission',
  isPurchaseItem: 'Is Purchase Item',
  deliveredBySupplier: 'Delivered By Supplier',
  noOfMonths: 'No of Months',
  allowNegativeStock: 'Allow Negative Stock',
  deferredExpense: 'Deferred Expense',
  assetCategory: 'Asset Category',
  isZeroRated: 'Is Zero Rated',
  MaterialRequest: 'Material Request',
  editMaterialRequest: 'Edit Material Request',
  sellingCostCenter: 'Selling Cost Center',
  expenseAccount: 'Expense Account',
  itemTaxTemplate: 'Item Tax Template',
  minimumNetRate: 'Minimum Net Rate',
  maximumNetRate: 'Maximum Net Rate',
  conversionFactor: 'Conversion Factor',
  uom: 'UOM',
  addMaterialRequest: 'Add Material Request',
  incomeAccount: 'Income Account',
  discountAccount: 'Discount Account',
  buyingCostCenter: 'Buying Cost Center',
  valuationMethod: 'Valuation Method',
  enableDeferredExpense: 'Enable Deferred Expense',
  noOfMonthsExp: 'No of Months Exp',
  purchaseUOM: 'Purchase UOM',
  fixedAsset: 'Fixed Asset',
  Item: 'Item',
  employeeDetails: 'Employement Details',
  employeePersonalDetails: 'Employement Personal Details',
  employeeContactDetails: 'Employement Contact Details',
  AddItem: 'Add Item',
  middleName: 'Middle Name',
  Insurances: 'Insurances',
  searchEligibilityPlan: 'Search Eligibility Plan',
  PatientInsurancePolicy: 'Patient Insurance Policy',
  deductions: 'Deductions',
  DeletetheItem: 'Delete the Item',
  services: 'Services',
  searchSalesInvoice: 'Search Sales Invoice',
  addtems: 'Add Items',
  deletetheDiagnosis: 'Delete the Diagnosis',
  Deletetheservice: 'Delete the service',
  AddItemPrice: 'Add Item Price',
  or: 'or',
  disabled: 'Disabled',
  id: 'ID',
  editService: 'Edit Service',
  itemDetails: 'Item Details',
  SubmittheSalesInvoice: 'Submit the Sales Invoice',
  SubmitthePaymentEntry: 'Submit the Payment Entry',
  account: 'Account',
  areYouSure: 'Are you sure?',
  editItems: 'Edit Items',
  DeletetheModeofFiscalYear: 'Delete the Mode of Fiscal Year',
  Finance: 'Finance',
  List: 'List',
  SearchFiscalYear: 'Search Fiscal Year',
  Tree: 'Tree',
  addService: 'Add Service',
  DefaultPriceList: 'Default Price List',
  addMaterial: 'Add Material',
  Credit: 'Credit',
  checkIn: 'Check In',
  InsuranceClaim: 'Insurance Claim',
  open: 'Open',
  approved: 'Approved',
  openStatus: 'Open',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
  checkedOut: 'Checked Out',
  parentDepartment: 'Parent Department',
  overwriteSalaryStructureAmount: 'Overwrite Salary Structure Amount',
  isRecurring: 'Is Recurring',
  deleteDepartment: 'Delete Department',
  FromDate: 'From Date',
  approver: 'Approver',
  ToDate: 'To Date',
  addInsuranceClaim: 'Add Insurance Claim',
  editDepartment: 'Edit Department',
  EnterInsurancePayorInformation: 'Enter Insurance Company Information',
  InsurancePayorInformation: 'Insurance Company Information',
  InsuranceClaimCreditDays: 'Insurance Claim Credit Days',
  InsurancePayorName: 'Insurance Company Name',
  AccountPaidTo: 'Account Paid To',
  HR: 'HR',
  customIdExpiryDate: 'ID Expiry Date',
  userId: 'User ID',
  active: 'Active',
  inactive: 'Inactive',
  CustomNationality: 'Nationality',
  suspended: 'Suspended',
  left: 'Left',
  customIdNumber: 'ID Number',
  dateOfJoining: 'Date of Joining',
  earnedLeaveFrequency: 'Earned Leave Frequency',
  Year: 'Year',
  advanceAccount: 'Advance Account',
  HalfYear: 'Half Year',
  payrollDate: 'Payroll Date',
  salaryComponent: 'Salary Component',
  EditAdditionalSalay: 'Edit Additional Salay',
  Quarter: 'Quarter',
  deleteAdditionalSalay: 'Delete Additional Salay',
  AdditionalSalay: 'Additional Salay',
  type: 'type',
  AddAdditionalSalay: 'Add Additional Salay',
  pendingAmount: 'Pending Amount',
  claimedAmount: 'Claimed Amount',
  returnAmount: 'Return Amount',
  purpose: 'Purpose',
  AccountCurrencyTo: 'Account Currency (To)',
  employeeName: 'Employee Name',
  DeleteEmployee: 'Delete Employee',
  EditEmployeeAdvance: 'Edit Employee Advance',
  repayUnclaimedAmountFromSalary: 'Repay Unclaimed Amount From Salary',
  UpdateEmployee: 'Update Employee',
  addLeaveAllocation: 'Add Leave Allocation',
  DeleteLeaveAllocation: 'Delete Leave Allocation',
  leaveAllocation: 'Leave Allocation',
  newLeavesAllocated: 'New Leaves Allocated',
  PaidAmount: 'Paid Amount',
  RecieptDetails: 'Reciept Details',
  value: 'Value',

  payrollCostCenter: 'Payroll Cost Center',
  bankName: 'Bank Name',
  SalaryMode: 'Salary Mode',
  companyName: 'Company Name',
  default: 'Default',
  allocateOnDay: 'Allocate on Day',
  firstDay: 'First Day',
  lastDay: 'Last Day',
  rounding: 'Rounding',
  salary: 'Salary',
  deleteSalaryComponent: 'Delete Salary Component',
  salaryComponent: 'Salary Component',
  totalExperience: 'Total Experience',
  cellNumber: 'Cell Number',
  formula: 'Formula',
  payrollFrequency: 'Payroll Frequency',
  totalDeduction: 'Total Deduction',
  totalEarning: 'Total Earning',
  variable: 'Variable',
  AddLeaveAllocation: 'Add Leave Allocation',
  SalaryStructureAssign: 'Salary Structure Assign',
  AddSalaryStructureAssign: 'Add Salary Structure Assign',
  UpdateSalaryStructureAssign: 'Update Salary Structure Assign',
  editSalaryComponent: 'Edit Salary Component',
  SalaryStructure: 'Salary Structure',
  payrollPayableAccount: 'Payroll Payable Account',
  UpdateSalaryStructure: 'Update Salary Structure',
  base: 'Base',
  deleteSalaryStructure: 'Delete Salary Structure',
  AddSalaryStructure: 'Add Salary Structure',
  amountBasedOnFormula: 'Amount Based on Formula',
  dependsOnPaymentDays: 'Depends on Payment Days',
  doNotIncludeInTotal: 'Do Not Include in Total',
  removeIfZeroValued: 'Remove if Zero Valued',
  roundToTheNearestInteger: 'Round to the Nearest Integer',
  contractEndDate: 'Contract End Date',
  designation: 'Designation',
  SalaryComponentAbbreviation: 'Salary Component Abbreviation',
  addSalaryComponent: 'Add Salary Component',
  addDesignation: 'Add Designation',
  EditDesignation: 'Edit Designation',
  deleteBranch: 'Delete Branch',
  Branch: 'Branch',
  StockLedger: 'Stock Ledger',
  BankTransfer: 'Bank Transfer',
  addBankTransfer: 'Add Bank Transfer',
  FreezeAccount: 'Freeze Account',
  addBranch: 'Add Branch',
  EditBranch: 'Edit Branch',
  editReceiptVoucher: 'Edit Receipt Voucher',
  stockBalance: 'Stock Balance',
  addReceiptVoucher: 'Add Receipt Voucher',
  StockBalanceList: 'Stock Balance List',
  expenseApprover: 'Expense Approver',
  deleteDesignation: 'Delete Designation',
  leaveApprover: 'Leave Approver',
  DateOfRetirement: 'Date of Retirement',
  PersonalEmail: 'Personal Email',
  AddEmployee: 'Add Employee',
  ExpenseApprovers: 'Expense Approvers',
  reportsTo: 'Reports To',
  EmergencyPhoneNumber: 'Emergency Phone Number',
  Relation: 'Relation',
  currentAddress: 'Current Address',
  PersonToBeContacted: 'Person To Be Contacted',
  CompanyEmail: 'Company Email',
  totalInvoiceAmount: 'Total Invoice Amount',
  RECEIPTENTRYINFORMATION: 'RECEIPT ENTRY INFORMATION',
  ReceiptInformation: 'Receipt Information',
  PerferredContactEmail: 'Preferred Contact Email',
  branch: 'Branch',
  MaterialReceipt: 'Material Receipt',
  pending: 'Pending',
  street: 'Street',
  state: 'State',

  customerAccounts: 'Customer Accounts',
  addSalesOrder: 'Add Sales Order',
  salesOrder: 'Sales Order',
  Employees: 'Employees',
  Customer: 'Customer',
  Patients: 'Patients',
  PaymentReferences: 'Payment References',
  Debit: 'Debit',
  TotalPatients: 'Total Patients',
  Party: 'Party',
  EditSalesInvoice: 'Edit Sales Invoice',
  AccountPaidFrom: 'Account Paid From',
  receivedQty: 'Received Qty',
  AccountingEntries: 'Accounting Entries',
  defaultUOM: 'Default UOM',
  returnedQty: 'Returned Qty',
  billedAmt: 'Billed Amt',
  CRNumber: 'CR Number',
  ReferenceDate: 'Reference Date',
  ChequeReferenceDate: 'Cheque/Reference Date',
  AccountCurrencyFrom: 'Account Currency (From)',
  PartyBalance: 'Party Balance',
  ChequeReferenceNo: 'Cheque/Reference No',
  Supplier: 'Supplier',
  landedCostVoucherAmount: 'Landed Cost Voucher Amount',
  Employee: 'Employee',
  Shareholder: 'Shareholder',
  conversionRate: 'Conversion Rate',
  plcConversionRate: 'PLC Conversion Rate',
  InsurancePayorEligibilityPlanInformation:
    'Insurance Company Eligibility Plan Information',
  ENTERPATIENTINSURANCEPOLICYINFORMATION:
    'ENTER PATIENT INSURANCE POLICY INFORMATION',
  PolicyExpiryDate: 'Policy Expiry Date',
  PriceList: 'Price List',
  includeDimensions: 'Include Dimensions',
  bodyMap: 'Body Map',
  download: 'Download',
  downloadPdf: 'Download PDF',
  sellingPriceList: 'Selling Price List',
  PleaseEnterValidData: 'Please enter valid data.',
  buyingPriceList: 'Buying Price List',
  includeDefaultBookEntries: 'Include Default Book Entries',
  priceListCurrency: 'Price List Currency',
  GeneralLedger: 'General Ledger',
  view: 'View',
  show: 'Show',
  ModeofPayment: 'Mode of Payment',
  dateEnd: 'Date End',
  selectTypeFormat: 'Select Type Format',
  SalesFinance: 'Sales & Finance',
  condition: 'Condition',
  Refunds: 'Refunds',
  Earnings: 'Earnings',
  ExportReport: 'Export Report',
  Manual: 'Manual',
  abbr: 'Abbr',
  SalesByLocations: 'Sales By Locations',
  SalesByLocations: 'Sales By Locations',
  ConversationRatio: 'Conversation Ratio',
  addItemEligibility: 'Add Item Eligibility',
  ItemEligibility: 'Item Eligibility',
  Automatic: 'Automatic',
  startDate: 'Start Date',
  ItemEligibilityInformation: 'Item Eligibility Information',
  coverage: 'Coverage',
  inWords: 'In Words',
  totalAdvance: 'Total Advance',
  addPurchaseInvoice: 'Add Purchase Invoice',
  AddStockReconcillation: 'Add Stock Reconcillation',
  EditStockReconcillation: 'Edit Stock Reconcillation',
  companyTrn: 'Company TRN',
  openingStock: 'Opening Stock',
  editAppointment: 'Edit Appointment',
  purpose: 'Purpose',
  differenceAmount: 'Difference Amount',
  valuationRate: 'Valuation Rate',
  templateDn: 'Template DN',
  StockReconcillation: 'Stock Reconcillation',
  setPostingTime: 'Set Posting Time',

  applyPutawayRule: 'Apply Putaway Rule',
  creditTo: 'Credit To',
  AddReceipt: 'Add Receipt',
  AddInvoice: 'Add Invoice',
  invoice: 'Invoice',
  discountType: 'Discount Type',
  remarks: 'Remarks',
  editPurchaseInvoice: 'Edit Purchase Invoice',
  againstExpenseAccount: 'Against Expense Account',
  onHold: 'On Hold',
  templateDt: 'Template DT',
  isReturn: 'Is Return',
  blockSupplier: 'Block Supplier',
  isSubcontracted: 'Is Subcontracted',
  useCompanyRoundoffCostCenter: 'Use Company Roundoff Cost Center',
  updateStock: 'Update Stock',
  invoices: 'Invoices',
  IncomingPaymentEntry: 'Incoming Payment Entry',
  DeletethePurchaseInvoice: 'Delete the Purchase Invoice',
  AddPurchaseInvoice: 'Add Purchase Invoice',
  OutgoingPaymentEntry: 'Outgoing Payment Entry',
  purchaseInvoice: 'Purchase Invoice',
  validFrom: 'Valid From',
  modeOfApproval: 'Mode of Approval',
  DeletethePurchaseReciept: 'Delete the Purchase Reciept',
  purchaseReciept: 'Purchase Reciept',
  PartyType: 'Party Type',
  postingDate: 'Posting Date',
  LeaveStatus: 'Leave Status',
  editPurchaseReciept: 'Edit Purchase Reciept',
  postingTime: 'Posting Time',
  addPurchaseReciept: 'Add Purchase Reciept',
  ReferenceNumber: 'Reference Number',
  InsurancePlanName: 'Insurance Plan Name',
  InsurancePayor: 'Insurance Company',
  DeletethePatientInsurancePolicy: 'Delete the Patient Insurance Policy',
  InsurancePlan: 'Insurance Plan',
  itemCode: 'Item Code',
  insurancePolicy: 'Insurance Policy',
  itemEligibility: 'Item Eligibility',
  discountAmount: 'Discount Amount',
  insurancePlan: 'Insurance Plan',
  AddPatientInsurancePolicy: 'Add Patient Insurance Policy',
  DeletetheInsurancePayor: 'Delete the Insurance Company',
  PolicyNumber: 'Policy Number',
  eligibilityPlan: 'Eligibility Plan',
  addEligibilityPlan: 'Add Eligibility Plan',
  deskTheme: 'Desk Theme',
  priority: 'Priority',
  addInsurancePayor: 'Add Insurance Company',
  insurancePayor: 'Insurance Company',
  lastName: 'Last Name',
  logoutAllSessions: 'Logout All Sessions',
  newPassword: 'New Password',
  coverage: 'Coverage',
  SearchInsurancePayor: 'Search Insurance Company',
  AddInsurancePayor: 'Add Insurance Company',
  gender: 'Gender',
  addLabItems: 'Add Lab Items',
  addRow: 'ADD ROW',
  patientName: 'Patient Name',
  fileNumber: 'File Number',
  email: 'Email',
  Single: 'Single',
  deleteAccount: 'Delete Account',
  Married: 'Married',
  Duning: 'Duning',
  DeletetheGeneralLedger: 'Delete the General Ledger',
  addJournalEntry: 'Add Journal Entry',
  searchJournalEntry: 'Search Title ',
  JournalEntry: 'Journal Entry',
  ENTERJOURNALENTRYINFORMATION: 'ENTER JOURNAL ENTRY INFORMATION',
  JournalEntryInformation: 'Journal Entry Information',
  EntryType: 'Entry Type',
  action: 'Action',
  Divorced: 'Divorced',
  SalesOrder: 'Sales Order',
  SalesInvoiceInformation: 'Sales Invoice Information',
  journal: 'Journal',
  ENTERSALESINVOICEINFORMATION: 'ENTER SALES INVOICE INFORMATION',
  AddSalesInvoice: 'Add Sales Invoice',
  patientNationality: 'Patient Nationality',
  salesInvoice: 'Sales Invoice',
  addNewItem: 'Add New Item',
  ThisWeek: 'This Week',
  Payments: 'Payments',
  taxId: 'Tax Id',
  totalMonthlySales: 'Total Monthly Sales',
  monthlySalesTarget: 'Monthly Sales Target',
  enablePerpetualInventory: 'Enable Perpetual Inventory',
  enableProvisionalAccountingForNonStockItems:
    'Enable Provisional Accounting For Non Stock Items',
  roundOffAccount: 'Round Off Account',
  roundOffCostCenter: 'Round Off Cost Center',
  defaultBankAccount: 'Default Bank Account',
  defaultCashAccount: 'Default Cash Account',
  EditChartAccount: 'Edit Chart Account',
  accountSettings: 'Account Settings',
  inventorySettings: 'Inventory Settings',
  salesSettings: 'Sales Settings',
  fixedAssetsSettings: 'Fixed Assets Settings',
  additionalSettings: 'Additional Settings',
  defaultInTransitWarehouse: 'Default In Transit Warehouse',
  Inventory: 'Inventory',
  TotalIncome: 'Total Income',
  LabTests: 'Lab Tests',
  holdType: 'Hold Type',
  Suppliers: 'Suppliers',
  releaseDate: 'Release Date',
  thisMonth: 'This Month',
  TotalExpenses: 'Total Expenses',
  PaymentsEntry: 'Payments Entry',
  ViewAll: 'View All',
  Missing: 'Missing',
  Ext: 'Ext',
  OVR: 'OVR',
  NYE: 'NYE',
  Crown: 'Crown',
  searchMaterialName: 'Search Material Name',
  Tilts: 'Tilts',
  DeletetheModeofPayment: 'Delete the Mode of Payment?',
  DeletetheBNPI: 'Delete the collection method?',
  DeletetheCostCenter: 'Delete the Cost Center',
  addressDetails: 'Address Details',
  DeletetheSalesInvoice: 'Delete the Sales Invoice',
  DeletetheDepartment: 'Delete the Department',
  zatcaInvoiceType: 'Zatca Invoice Type',
  DeletetheServiceUnit: 'Delete the Service Unit',
  addressName: 'Address Name',
  DeletetheMaterial: 'Delete the Material',
  Materials: 'Materials',
  ReviewDetails: 'Review Details',
  serviceUnits: 'Service Units',
  EditCostCenter: 'Edit Cost Center',
  AddBNPI: 'Add collection method',
  collectionmethod: 'collection method',
  searchByName: 'Search By Name',
  DentalMaterial: 'Dental Material',
  searchServiceUnitName: 'Search Service Units',
  Widow: 'Widow',
  scheduleDate: 'Schedule Date',
  CompanyInformation: 'Company Information',
  materialRequestType: 'Material Request Type',
  editWarehouse: 'Edit Warehouse',
  DeletetheWarehouse: 'Delete the Warehouse',
  owner: 'Owner',
  AccountsSettings: 'Accounts Settings',
  customAdvancePaymentAccount: 'Custom Advance Payment Account',
  age: 'Age',
  totalMonthlySales: 'total Monthly Sales',

  allowAccountCreationAgainstChildCompany:
    'Allow Account Creation Against Child Company',
  SeriesForDepreciationEntry: 'Series For Depreciation Entry',
  FixedAssetSettings: 'Fixed Asset Settings',
  autoExchangeRateRevaluation: 'Auto Exchange Rate Revaluation',
  StockSettings: 'Stock Settings',
  creditLimit: 'Credit Limit',
  autoErrFrequency: 'Auto Err Frequency',
  defaultHolidayList: ' Holiday List',
  Root: 'Root',
  crNumber: 'CR Number',
  enablePerpetualInventory: 'Enable Perpetual Inventory',
  enableProvisionalAccountingForNonStockItems:
    'Enable Provisional Accounting For Non Stock Items',
  defaultExpenseClaimPayableAccount: 'default Expense Claim Payable Account',
  website: 'Website',
  HRPayrollSettings: 'HR & Payroll Settings',
  customDefaultDownPaymentItem: 'custom Default Down Payment Item',
  monthlySalesTarget: 'Monthly Sales Target',
  BuyingSellingSettings: 'Buying & Selling Settings',
  fgItemQty: 'FG Item Qty',
  companyDescription: 'Company Description',
  customCrNumber: 'CR Number',
  receivedStockQty: 'Received Stock Qty',
  isZeroRated: 'Is Zero Rated',
  custom_zatca_tax_category: 'Custom Zatca Tax Category',
  custom_exemption_reason_code: 'Exemption Reason Code',
  isExempt: 'Is Exempt',
  editAccountPeriod: 'Edit Account Period',
  editModeOfPayment: 'Edit Mode of Payment',
  customBuyerIdType: 'Buyer Id Type',
  custom_zatca_status: 'Custom Zatca Status',
  addAddress: 'Add Address',
  custom_vat_registration_number: 'VAT Registration Number',
  custom_submit_line_item_discount_to_zatca:
    'Submit Line Item Discount To Zatca',
  email: 'Email',
  EnterYourEmail: 'Enter Your Email',
  customer: 'Customer',
  password: 'Password',
  PleaseInputYourPassword: 'Please Input Your Password',
  EnterYourPassword: 'Enter Your Password',
  customBuyerId: 'Buyer Id',
  KeepMeConnected: 'Keep Me Connected',
  AllRightsReservedDHAYAELALDAN: 'All Rights Reserved DHAYAELALDAN',
  Login: 'Login',
  RestorePassword: 'Restore Password',
  custom_zatca_discount_reason: 'Zatca Discount Reason',
  custom_zatca_discount_reason_code: 'Zatca Discount Reason Code',
  custom_user_invoice_number: 'Customer Invoice Number',
  customer_primary_address: 'Customer primary Address',
  custom_zatca_tax_category: 'Zatca Tax Category',
  customSelfBilledInvoice: 'Self Billed Invoice',
  custom_b2c: 'B2C',
  PleaseInputYourEmail: 'Please Input Your Email',
  InvalidEmail: 'Invalid Email',
  username: 'Username',
  PleaseInputYourUsername: 'Please Input Your Username',
  supplier_primary_address: 'Supplier primary Address',
  voucher: 'Voucher',
  Welcome: 'Welcome',
  Search: 'Search',
  is_primary_address: 'Is Primary Address',
  address_title: 'Address Title',
  SubmitToZatca: 'Submit To Zatca',
  type: 'type',
  city: 'City',
  address_in_arabic: 'Address In Arabic',
  customers: 'Customers',
  is_shipping_address: 'Is Shipping Address',
  custom_buiding_number: 'Building Number',
  customSummaryInvoice: 'Summary Invoice',
  customZatcaThirdPartyInvoice: 'Third Party Invoice',
  DeletetheAddress: 'Delete the Address',
  downloadZatcaPdf: 'Download Zatca Pdf',
  downloadZatcaXML: 'Download Zatca XML',
  GetZatcaDetails: 'Get Zatca Details',
  EditAddress: 'Edit Address',
  custom_area: 'Area',
  customZatcaExportInvoice: 'Export Invoice',
  custom_uuid: 'Custom Uuid',
  customZatcaNominalInvoice: 'Nominal Invoice',
  phoneNumber: 'Phone Number',
  deferredExpenseAccount: 'Deferred Expense Account',
  warehouseName: 'Warehouse Name',
  Encounters: 'Encounters',
  searchEncounter: 'Search Encounters',
  image: 'Image',
  Upload: 'Upload',
  isActive: 'Is Active',
  address: 'Address',
  occupation: 'Occupation',
  city: 'City',
  nieghborhood: 'Nieghborhood',
  Country: 'Country',
  time: 'Time',
  labTest: 'Lab Test',
  General: 'General',
  addLabTest: 'Add Lab Test',
  labTestName: 'Lab Test Name',
  unitofMeasure: 'Unit of Measure',
  buying: 'Buying',
  selling: 'Selling',
  unitMeasureName: 'Unit Measure Name',
  UnitMeasure: 'Unit Measure',
  editPriceList: 'Edit Price List',
  addUnitMeasure: 'Add Unit Measure',
  editUnitMeasure: 'Edit Unit Measure',
  mustBeWholeNumber: 'Must be whole number',
  enabled: 'Enabled',
  ItemPrice: 'Item Price',
  addItemPrice: 'Add Item Price',
  editItemPrice: 'Edit Item Price',
  disabled: 'Disabled',
  wholeNumber: 'Whole Number',
  decimalNumber: 'Decimal Number',
  priceListRate: 'Price List Rate',
  DeleteUnitMeasure: 'Delete Unit Measure',
  priceListName: 'Price List Name',
  addPriceList: 'Add Price List',
  priceList: 'Price List',
  DeletePriceList: 'Delete Price List',
  maintainStock: 'Maintain Stock',
  purchaseItem: 'Purchase Item',
  DeleteItem: 'Delete Item',
  shelfLifeInDays: 'Shelf Life In Days',
  includeItemInManufacturing: 'Include Item In Manufacturing',
  priceList: 'Price List',
  currency: 'Currency',
  validUpto: 'Valid Upto',
  AvailableSale: 'Available Sale',
  NotAvailableSale: 'Not Available Sale',
  Activated: 'Activated',
  Deactivated: 'Deactivated',
  sales: 'Sales',
  Delete: 'Delete',
  editSalesOrder: 'Edit Sales Order',
  totalTaxesAndCharges: 'Total Taxes And Charges',
  salesItem: 'Sales Item',
  generalLedger: 'General Ledger',
  addGeneralLedger: 'Add General Ledger',
  editGeneralLedger: 'Edit General Ledger',
  inventoryInformation: 'Inventory Information',
  ENTERINVENTORYINFORMATION: 'ENTER INVENTORY INFORMATION',
  itemPrice: 'Item Price',
  SubmitSalesInvoice: 'Submit Sales Invoice',
  bloodGroup: 'Blood Group',
  IdNumber: 'ID Number',
  mobile: 'Mobile',
  CreateFullPaymentInvoice: 'Create Full Payment Invoice',
  CreateDownPaymentInvoice: 'Create Down Payment Invoice',
  CommercialRegistryNumber: 'Commercial Registry Number',
  CustomerID: 'Customer ID',
  ENTERRECONCILIATION: 'ENTER RECONCILIATION',
  AccountsPayable: 'Accounts Payable',
  Orders: 'Orders',
  mainCostCenter: 'Main Cost Center',
  TotalEarning: 'Total Earning',
  MyBalance: 'My Balance',
  Revenue: 'Revenue',
  SeeDetails: 'See Details',
  GoodMorning: 'Good Morning',
  AddProduct: 'Add Product',
  WithdrawMoney: 'Withdraw Money',
  ViewAllOrders: 'View All Orders',
  ViewNetEarnings: 'View Net Earnings',
  Customers: 'Customers',
  Heresthatshappeningwithyourstoretoday:
    "Here's what's happening with your company today.",
  messageErorrReconcile:
    'There is an error in the distribution of the allocated amount. Ensure that the allocated amount does not exceed the remaining amount to be paid.',
  messageErorrReconcileTwo:
    'Payment Entry has been modified after you pulled it. Please pull it again.',
  Invoices: 'Invoices',
  AddCostCenterAllocation: 'Add Cost Center Allocation',
  charge_item: 'Charge Item',
  op_consulting_charge: 'Op Consulting Charge',
  select_invoice: 'Select Invoice',
  appointmentDate: 'Appointment Date',
  addMaterialWarehouse: 'Add Material Warehouse',
  expenseAccount: 'Expense Account',
  orderedQty: 'Ordered Qty',
  warehouse: 'Warehouse',
  receivedQty: 'Received Qty',
  Purchase: 'Purchase',
  MaterialTransfer: 'Material Transfer',
  appointmentTime: 'Appointment Time',
  MaterialIssue: 'Material Issue',
  materialReceipt: 'Material Receipt',
  Return: 'Return',
  taxes: 'Taxes',
  purchaseReturn: 'Purchase Return',
  Manufacture: 'Manufacture',
  materialRequest: 'Material Request',
  Rate: 'Rate',
  transactionDate: 'Transaction Date',
  scheduleDate: 'Schedule Date',
  setWarehouse: 'Set Warehouse',
  stockQty: 'Stock Qty',
  taxesDetails: 'Taxes Details',
  includedInPaidAmount: 'Included In Paid Amount',
  minOrderQty: 'Min Order Qty',
  projectedQty: 'Projected Qty',
  actualQty: 'Actual Qty',
  includedInPrintRate: 'Included In Print Rate',
  paymentSchedule: 'Payment Schedule',
  MaterialWarehouses: 'Material Warehouses',
  appointmentType: 'Appointment Type',
  DeletetheMaterialWarehouse: 'Delete the Material Warehouse',
  department: 'Department',
  addPatientInsuranceCoverage: 'Add Patient Insurance Coverage',
  status: 'Status',
  zatca_payment_means_code: 'Zatca Payment Means Code',
  country: 'Country',
  pincode: 'Postal Code',
  editSupplier: 'Edit Supplier',
  zatcaStatus: 'Zatca Status',
  invalidPincode: 'Invalid Pincode Please Enter Valid Pincode',
  custom_return_reason: 'Return Reason',
  AdditionalIds: 'Additional Ids',
  Numbermustbe15digits: 'Number must be 15 digits',
  Numbermuststartwith3: 'Number must start with 3',
  Numbermustendwith3: 'Number must end with 3',
  creditNote: 'Credit Note',
  please_enter_at_least_one_additional_ids:
    'Please enter at least one additional ids',
  return_against: 'Return Against',
  zatcaDetails: 'Zatca Details',
  salesInvoiceCredit: 'Sales Invoice Credit',
  AddSalesInvoiceCredit: 'Add Sales Invoice Credit',
  message: 'Message',
  addWarehouse: 'Add Warehouse',
  Warehouses: 'Warehouses',
  ParentWarehouse: 'Parent Warehouse',
  addSupplier: 'Add Supplier',
  DeletetheSupplier: 'Delete the Supplier',
  AddSupplierGroup: 'Add Supplier Group',
  NameInArabic: 'Name In Arabic',
  NameInEnglish: 'Name In English',
  state: 'State',
  identificationNumber: 'Identification Number',
  country: 'Country',
  InvoiceDetails: 'Invoice Details',
  CreateModeOfPayment: 'Create Mode Of Payment',
  postalCode: 'Postal Code',
  maritalStatus: 'Marital Status',
  InvoiceNumber: 'Invoice Number',
  addPatient: 'Add Patient',
  Entermodeofpaymentinformation: 'Enter mode of payment information',
  ModeofPaymentInformation: 'Mode of Payment Information',
  labTestInformation: 'Lab Test Information',
  eNTERLABTESTINFORMATION: 'ENTER LAB TEST INFORMATION',
  testTemplate: 'Test Template',
  employeeLab: 'Employee (Lab Technician)',
  company: 'Company',
  Individual: 'Individual',
  voucherType: 'Voucher Type',
  swiftNumber: 'Swift Number',
  AddBankAccount: 'Add Bank Account',
  EditBankAccount: 'Edit Bank Account',
  Number: 'Number',
  addBank: 'Add Bank',
  EditBank: 'Edit Bank',
  LinkedDocs: 'Linked Docs',
  Unlink: 'Unlink',
  itemName: 'Item Name',
  AddModeOfPayment: 'Add Mode Of Payment',
  type: 'Type',
  shelfLifeInDays: 'Shelf Life In Days',
  RejectedClaimsExpenseAccount: 'Rejected Claims Expense Account',
  ClaimsReceivableAccount: 'Claims Receivable Account',
  price: 'Price',
  AccountCurrency: 'Account Currency',
  percentage: 'Percentage',
  percentageError: 'Percentage must be between 0 and 100',
  GetLastEncounters: 'Get Last Encounters',
  unitofMeasure: 'Unit of Measure',
  DeletetheLabTest: 'Delete the Lab Test?',
  editEncounter: 'Edit Encounter',
  materialName: 'Material Name',
  searchItems: 'Search Items',
  Areyousuretodeletethislabtest: 'Are you sure to delete this lab test?',
  EncounterComment: 'Encounter Comment',
  comment: 'Comment',
  SearchLabTests: 'Search Lab Tests',
  GetLastInvoices: 'Get Last Invoices',
  editLabTest: 'Edit Lab Test',
  reportType: 'Report Type',
  AddService: 'Add Service',
  SubmittheEncounter: 'Submit the Encounter',
  AreyousuretobesubmitthisEncounter: 'Are you sure to submit this encounter?',
  searchEncounter: 'Search Encounters',
  DeletetheEncounter: 'Delete the Encounter?',
  AreyousuretodeletethisEncounter: 'Are you sure to delete this encounter?',
  DeletethePatient: 'Delete the Patient',
  Areyousuretodeletethispatient: 'Are you sure to delete this patient?',
  user_remark: 'User Remark',
  DeletethePractitioner: 'Delete the Practitioner',
  Areyousuretodeletethispractitioner:
    'Are you sure to delete this practitioner?',
  isgroup: 'Is Group',
  cost_center_number: 'Cost Center Number',
  yes: 'Yes',
  LandedCostVoucher: 'Landed Cost Voucher',
  deleteEmployeeAdvance: 'Delete Employee Advance',
  EmployeeAdvance: 'Employee Advance',
  AddEmployeeAdvance: 'Add Employee Advance',
  advanceAmount: 'Advance Amount',
  receiptDocument: 'Receipt Document',
  applicableCharges: 'Applicable Charges',
  editLandedCostVoucher: 'Edit Landed Cost Voucher',
  DistributeManually: 'Distribute Manually',
  deleteExpenseClaim: 'Delete Expense Claim',
  distributeChargesBasedOn: 'Distribute Charges Based On',
  PurchaseReceipts: 'Purchase Receipts',
  receiptDocumentType: 'Receipt Document Type',
  returnInvoiceId: 'Return Invoice ID',
  is_paid: 'is paid',
  RootType: 'Root Type',
  expenseType: 'Expense Type',
  EditExpenseClaim: 'Edit Expense Claim',
  AddLandedCostVoucher: 'Add Landed Cost Voucher',
  deleteLandedCostVoucher: 'Delete Landed Cost Voucher',
  total_debit: 'Total Debit',
  total_credit: 'Total Credit',
  expenseClaim: 'Expense Claim',
  addExpenseClaim: 'Add Expense Claim',
  no: 'No',
  purchaseOrder: 'Purchase Order',
  parentItemGroup: 'Parent Item Group',
  itemGroupName: 'Item Group Name',
  customItemGroupId: 'Group ID',
  addItemGroup: 'Add Item Group',
  editItemGroup: 'Edit Item Group',
  editPurchaseOrder: 'Edit Purchase Order',
  purchaseOrder: 'Purchase Order',
  addPurchaseOrder: 'Add Purchase Order',
  Accounts: 'Accounts',
  supplierName: 'Supplier Name',
  Account: 'Account',
  CostCenterName: 'Cost Center Name',
  parentcostcenter: 'Parent Cost Center',
  ParentCostCenter: 'Parent Cost Center',
  plusRiyal: 'Plus Riyal',
  medicalCoding: 'Medical Coding',
  medicalCode: 'Medical Code',
  medicalCodeStandard: 'Medical Code Standard',
  code: 'Code',
  AssignedByFullName: 'Assigned By Full Name',
  AllocatedTo: 'Allocated To',
  Date: 'Date',
  LastModified: 'Last Modified',
  CreationDate: 'Creation Date',
  showTask: 'Show Task',
  description: 'Description',
  TodoList: 'Todo List',
  ReferenceName: 'Reference Name',
  ReferenceType: 'Reference Type',
  AssignedBy: 'Assigned By',
  EditTask: 'Edit Task',
  AssignTo: 'Assign To',
  AssignTask: 'Assign Task',
  worksheetPrint: 'Worksheet Print',
  resultLegendPrint: 'Result Legend Print',
  printPosition: 'Print Position',
  resultLegend: 'Result Legend',
  No: 'No',
  Yes: 'Yes',
  ParentAccount: 'Parent Account',
  requestingDepartment: 'Requesting Department',
  reports: 'Reports',
  integration_status: 'Integration Status',
  DeletetheAppointment: 'Delete the Appointment',
  Areyousuretodeletethisappointment: 'Are you sure to delete this appointment?',
  Print: 'Print',
  accountDetails: 'Account Details',
  company_address: 'Company Address',
  patient: 'Patient',
  practitioners: 'Practitioners',
  changeStatus: 'Change Status',
  practitionerSchedule: 'Practitioner Schedule',
  reference_type: 'Reference Type',
  reference_name: 'Reference Name',
  date: 'Date',
  medialHistory: 'Medial History',
  ReportType: 'Report Type',
  RootType: 'Root Type',
  printLanguage: 'Print Language',
  inPatientItem: 'Inpatient Visit Charge Item',
  medicalDepartment: 'Medical Department',
  submit: 'Submit',
  practitionerName: 'Practitioner Name',
  practitionerNo: 'Practitioner No',
  CostCenterNumber: 'Cost Center Number',
  medicalDepartment: 'Medical Department',
  status: 'Status',
  addCostCenter: 'Add Cost Center',
  titleCardAddPractitioner: 'ENTER PRACTITIONER INFORMATION',
  createPractitioner: 'Create Practitioner',
  editPractitioner: 'Edit Practitioner',
  practitioner: 'Practitioner',
  patientInformation: 'Patient Information',
  practitionerName: 'Practitioner Name',
  todayAppointments: 'Today',
  tomorrowAppointments: 'Tomorrow',
  departmentName: 'Department Name',
  addDepartment: 'Add Department',
  addPractitionerSchedule: 'Add Practitioner Schedule',
  searchDepartment: 'Search Department',
  Name: 'Name',
  COUNTRYSTATISTICS: 'COUNTRY STATISTICS',
  WEEKLYVISITORS: 'WEEKLY VISITORS',
  encounterID: 'Encounter ID',
  material: 'Material',
  addEncounter: 'Add Encounter',
  SALESACTIVITY: 'SALES ACTIVITY',
  AccountHead: 'Account Head',
  TaxRate: 'Tax Rate',
  PaymentType: 'Payment Type',
  TIMELINE: 'TIMELINE',
  MAINTASKS: 'MAINTASKS',
  PRODUCTSUMMARY: 'PRODUCT SUMMARY',
  Outstanding: 'Outstanding',
  AccountType: 'Account Type',
  AccountInformation: 'Account Information',
  AccountName: 'Account Name',
  AddAccount: 'Add Account',
  AccountNumber: 'Account Number',
  GroupAccount: 'Group Account',
  SearchAccountName: 'Search Account Name',
  RECENTTRANSACTIONS: 'RECENT TRANSACTIONS',
  ChartAccount: 'Chart of Accounts',
  AddChartAccount: 'Add Chart of Accounts',
  editPaymentEntry: 'Edit Payment Entry',
  Allocated: 'Allocated',
  Processing: 'Processing',
  Deletethepaymententry: 'Delete the payment entry?',
  searchPartyName: 'Search Party',
  paymentEntry: 'Payment Entry',
  InternalTransfer: 'Internal Transfer',
  PaymentEntryInformation: 'Payment Entry Information',
  Receive: 'Receive',
  Pay: 'Pay',
  ENTERPAYMENTENTRYINFORMATION: 'ENTER PAYMENT ENTRY INFORMATION',
  TaxAmount: 'Tax Amount',
  GrandTotal: 'Grand Total',
  deleteCustomer: 'Delete Customer',
  GetLinkedPayments: 'Get Linked Payments',
  LinkedPayments: 'Linked Payments',
  customerNameInArabic: 'Customer Name in Arabic',
  employeeAdvance: 'Employee Advance',
  editCustomer: 'Edit Customer',
  unclaimedAmount: 'Unclaimed Amount',
  totalSanctionedAmount: 'Total Sanctioned Amount',
  totalClaimedAmount: 'Total Claimed Amount',
  EditExpenseClaim: 'Edit Expense Claim',
  addCustomer: 'Add Customer',
  customerDetails: 'Customer Details',
  advancePaid: 'Advance Paid',
  AddPaymentEntry: 'Add Payment Entry',
  Total: 'Total',
  netTotal: 'Net Total',
  expenses: 'Expenses',
  expenseType: 'Expense Type',
  sanctionedAmount: 'Sanctioned Amount',
  expenseDate: 'Expense Date',
  advances: 'Advances',
  addDeductTax: 'Add deduct Tax',
  discountPercentage: 'Discount Percentage',
  chargeType: 'Charge Type',
  accountHead: 'Account Head',
  costCenter: 'Cost Center',
  Category: 'Category',
  additionalDiscountPercentage: 'Additional Discount Percentage',
  roundedTotal: 'Rounded Total',
  disableRoundedTotal: 'Disable Rounded Total',
  grandTotal: 'Grand Total',
  applyDiscountOn: 'Apply Discount On',
  baseDiscountAmount: 'Base Discount Amount',
  roundingAdjustment: 'Rounding Adjustment',
  TotalTaxesandCharges: 'Total Taxes and Charges',
  baseRoundedTotal: 'Base Rounded Total',
  TotalTaxesandCharges: 'Total Taxes and Charges',
  TaxesandCharges: 'Taxes and Charges',
  enterEncounterInformation: 'Enter Encounter Information',
  encounterInformation: 'Encounter Information',
  encounterimpression: 'Encounter Impression',
  items: 'Items',
  discount: 'Discount',
  paymentAmount: 'Payment Amount',
  reviewDetails: 'Review Details',
  symptoms: 'Symptoms',
  diagnosis: 'Diagnosis',
  quantity: 'Quantity',
  outstanding: 'Outstanding',
  totalQty: 'Total Qty',
  ignorePricingRule: 'Ignore Pricing Rule',
  SupplierNameInArabic: 'Supplier Name In Arabic',
  accountingDimensions: 'Accounting Dimensions',
  currencyAndPriceList: 'Currency And Price List',
  approvedAmount: 'Approved Amount',
  claimAmount: 'Claim Amount',
  paymentDays: 'Payment Days',
  customerName: 'Customer Name',
  customerGroup: 'Customer Group',
  customerType: 'Customer Type',
  territory: 'Territory',
  total_deduction: 'Total Deduction',
  netPay: 'Net Pay',
  abbr: 'Abbr',
  salary_component: 'Salary Component',
  year_to_date: 'Year To Date',
  salary_component: 'Salary Component',
  net_pay: 'Net Pay',
  total_earnings: 'Total Earnings',
  total_in_words: 'Total In Words',
  rounded_total: 'Rounded Total',
  gross_year_to_date: 'Gross Year To Date',
  gross_pay: 'Gross Pay',
  absentDays: 'Absent Days',
  totalWorkingDays: 'Total Working Days',
  leaveWithoutPay: 'Leave Without Pay',
  addSalarySlip: 'Add Salary Slip',
  EditSalarySlip: 'Edit Salary Slip',
  salarySlip: 'Salary Slip',
  deletePractitionerSchedule: 'Delete Practitioner Schedule',
  searchItemCode: 'Search Item Code',
  ENTERINSURANCECLAIMINFORMATION: 'ENTER INSURANCE CLAIM INFORMATION',
  EDITINSURANCECLAIMINFORMATION: 'EDIT INSURANCE CLAIM INFORMATION',
  discountAmount: 'Discount Amount',
  paidAmount: 'Paid Amount',
  paymentErrorReason: 'Payment Error Reason',
  patientPayable: 'Patient Payable',
  qtyInvoiced: 'Qty Invoiced',
  Patient: 'Patient',
  discountedAmount: 'Discounted Amount',
  topCustomers: 'Top Customers',
  basePaymentAmount: 'Base Payment Amount',
  confirmDelete: 'Confirm Delete',
  suppliersName: 'Suppliers Name',
  topItems: 'Top Items',
  Reconcile: 'Reconcile',
  CountSalesOrder: 'Sales Order Count',
  ReceiptVoucher: 'Receipt Voucher',
  AddExpenseClaim: 'Add Expense Claim',
  PaymentVoucher: 'Payment Voucher',
  CountPo: 'Purchase Order Count',
  Tax: 'Tax',
  Count: 'Count',
  Amount: 'Amount',
  SAR: 'SAR',
  Advance: 'Advance',
  totalSalesOrder: 'Total Sales Order',
  totalSalesOrderCount: 'Total Sales Order Count',
  ExpenseClaim: 'Expense Claim',
  totalSalesOrderAdvance: 'Total Sales Order Advance',
  totalSalesOrderAmount: 'Total Sales Order Amount',
  PaymentsList: 'Payments List',
  InvoicesList: 'Invoices List',
  invoiceDate: 'Invoice Date',
  outstandingAmount: 'Outstanding Amount',
  totalSalesOrderCount: 'Total Sales Order Count',
  totalSalesOrderTax: 'Total Sales Order Tax',
  Reconcillation: 'Reconcillation',
  EDITPATIENTDETAILS: 'EDIT PATIENT DETAILS',
  InsuranceClaimAmount: 'Insurance Claim Amount',
  ENTERPATIENTDETAILS: 'ENTER PATIENT DETAILS',
  rate: 'Rate',
  coverageAmount: 'Coverage Amount',
  coverageAmountInvoiced: 'Coverage Amount Invoiced',
  amount: 'Amount',
  departmentInformation: 'Department Information',
  AddIllness: 'Add Illness',
  NameArabic: 'Name Arabic',
  NameEnglish: 'Name English',
  itemGroups: 'Item Groups',
  itemGroup: 'Item Group',
  serviceUnitName: 'Service Unit Name',
  EnterIllnessInformation: 'Enter Illness Information',
  EditIllnessInformation: 'Edit Illness Information',
  Healthcare: 'Healthcare',
  allocatedPercentage: 'Allocated Percentage',
  allowAppointments: 'Allow Appointments',
  inpatientOccupancy: 'Inpatient Occupancy',
  serviceUnitType: 'Service Unit Type',
  RescheduleAppointment: 'Reschedule Appointment',
  warehouse: 'Warehouse',
  SalesTeam: 'Sales Team',
  deliveryDate: 'Delivery Date',
  salesPerson: 'Sales Person',
  incentives: 'Incentives',
  addServiceUnit: 'Add Service Unit',
  AppointmentDuration: 'Appointment Duration',
  Duration: 'Duration',
  AddAppointmentDuration: 'Add Appointment Duration',
  allowbookingfor: 'Allow booking for',
  ReferringPractitioner: 'Referring Practitioner',
  encounterDate: 'Encounter Date',
  encounterTime: 'Encounter Time',
  ENTERFISCALYEARINFORMATION: 'ENTER FISCAL YEAR INFORMATION',
  healthcarePractitioner: 'Healthcare Practitioner',
  officePhone: 'Office Phone',
  confirm: 'Confirm',
  YearEndDate: 'Year End Date',
  FiscalYears: 'Fiscal Years',
  YearStartDate: 'Year Start Date',
  AddFiscalYear: 'Add Fiscal Year',
  ENTERDEPARTMENTINFORMATION: 'ENTER DEPARTMENT INFORMATION',
  ENTERPractitionerScheduleFORMATION: 'ENTER PRACTITIONER SCHEDULE INFORMATION',
  ENTERSERVICEUNITINFORMATION: 'ENTER SERVICE UNIT INFORMATION',
  ENTERMATERIALINFORMATION: 'ENTER MATERIAL INFORMATION',
  FiscalYear: 'Fiscal Year',
  DefaultAccount: 'Default Account',
  reject: 'Reject',
  time_slots: 'Time Slots',
  SessionTime: 'Session Time',
  schedule_name: 'Schedule Name',
  birthDate: 'Birth Date',
  PatientCoverage: 'Patient Coverage',
  addPractitioner: 'Add Practitioner',
  financialDetails: 'Financial Details',
  searchPatient: 'Search Patient',
  patientHistory: 'Patient History',
  patientCareType: 'Patient Care Type',
  InternalSend: 'phone',
  practitionerType: 'Practitioner Type',
  requiredPractitionerType: 'Please enter practitioner type',
  requiredFirstName: 'Please enter first name',
  requiredMiddleName: 'Please enter middle name',
  internal: 'Internal',
  external: 'External',
  Tabby: 'Tabby',
  Tamara: 'Tamara',
  bankAccount: 'Bank Account',
  All: 'All',
  level: 'Level',
  undefined: 'Undefined',
  yearOfPassing: 'Year Of Passing',
  cash: 'Cash',
  defaultCurrency: 'Currency',
  defaultDiscountAccount: 'Discount Account',
  defaultEmployeeAdvanceAccount: 'Employee Advance Account',
  ValidUpto: 'Valid Upto',
  notAvailable: 'Not Available',
  companyDetails: 'Company Details',
  defaultExpenseAccount: 'Expense Account',
  defaultExpenseClaimPayableAccount: 'Expense Claim Payable Account',
  reasonForLeaving: 'Reason For Leaving',
  defaultIncomeAccount: 'Income Account',
  defaultInventoryAccount: 'Inventory Account',
  schoolUniv: 'Education',
  salesInfo: 'Sales Info',
  systemInfo: 'System Info',
  modifiedBy: 'Modified By',
  stockReceivedButNotBilled: 'Stock Received But Not Billed',
  docType: 'Doc Type',
  docStatus: 'Doc Status',
  defaultPayableAccount: 'Payable Account',
  defaultPayrollPayableAccount: 'Payroll Payable Account',
  defaultProvisionalAccount: 'Provisional Account',
  accumulatedDepreciationAccount: 'Accumulated Depreciation Account',
  qualification: 'Qualification',
  canceltheAppointment: 'Cancel the Appointment',
  AreyousuretoCancelthisappointment: 'Are you sure to Cancel this appointment?',
  accountingInfo: 'Accounting Info',
  additionalDetails: 'Additional Details',
  creditLimit: 'Credit Limit',
  OutstandingAmount: 'Outstanding Amount',
  chartOfAccounts: 'Chart Of Accounts',
  autoExchangeRateRevaluation: 'Auto Exchange Rate Revaluation',
  assetReceivedButNotBilled: 'Asset Received But Not Billed',
  depreciationCostCenter: 'Depreciation Cost Center',
  disposalAccount: 'Disposal Account',
  capitalWorkInProgressAccount: 'Capital Work In Progress Account',
  stockReceivedButNotBilled: 'Stock Received But Not Billed',
  defaultDiscountAccount: 'Discount Account',
  stockAdjustmentAccount: 'Stock Adjustment Account',
  defaultExpenseAccount: 'Expense Account',
  defaultProvisionalAccount: 'Provisional Account',
  defaultIncomeAccount: 'Income Account',
  defaultDeferredExpenseAccount: 'Deferred Expense Account',
  relievingDate: 'Relieving Date',
  unrealizedProfitLossAccount: 'Unrealized Profit Loss Account',
  exchangeGainLossAccount: 'Exchange Gain Loss Account',
  defaultStockAdjustmentAccount: 'Stock Adjustment Account',
  defaultStockReceivedButNotBilled: 'Stock Received But Not Billed',
  defaultUnrealizedProfitLossAccount: 'Unrealized Profit Loss Account',
  defaultWriteOffAccount: 'Write Off Account',
  depreciationExpenseAccount: 'Depreciation Expense Account',
  writeOffAccount: 'Write Off Account',
  defaultUnrealizedExchangeGainLossAccount:
    'Unrealized Exchange Gain Loss Account',
  defaultReceivableAccount: 'Receivable Account',
  IBAN: 'IBAN',
  defaultInTransitWarehouse: 'In Transit Warehouse',
  defaultDepreciationExpenseAccount: 'Depreciation Expense Account',
  defaultDepreciationCostCenter: 'Depreciation Cost Center',
  chartofaccounts: 'Chart of Accounts',
  defaultDeferredRevenueAccount: 'Deferred Revenue Account',
  ExitDetailes: 'Exit Detailes',
  EducationDetailes: ' Education Detailes',
  SalaryDetailes: 'Salary Detailes',
  maritalStatus: 'Marital Status',
  passportNumber: 'Passport Number',
  ValidFrom: 'Valid From',
  MainCostCenter: 'Main Cost Center',
  BankAccountNo: 'Bank Account No',
  BranchCode: 'Branch Code',
  Bank: 'Bank',
  PurchaseInvoice: 'Purchase Invoice',
  CanceltheDebitNote: 'Cancel the Debit Note',
  Pleaseinputaninteger: 'Please input an integer',
  Specialty: 'Specialty',
  EditPaymentMethod: 'Edit Payment Method',
  item: 'Item',
  stockReconcillation: 'Stock Reconcillation',
  stockEntry: 'Stock Entry',
  PaymentMethod: 'Payment Method',
  addPaymentMethod: 'Add Payment Method',
  contract_type: 'Contract Type',
  fromDate: 'From Date',
  outPatient: 'Out Patient Consulting Charge Item',
  sampleLab: 'Sample Lab',
  dueDate: 'Due Date',
  invoicePortion: 'Invoice Portion',
  payableAccount: 'Payable Account',
  paymentAccount: 'Payment Account',
  isDefault: 'Is Default',
  paymentDueDate: 'Payment Due Date',
  approvalStatus: 'Approval Status',
  practitionerSchedule: 'Practitioner Schedule',
  areYouSuretoCreditNotes: 'Are you sure to Credit Notes?',
  CreditNote: 'Credit Note',
  editProfile: 'Edit Profile',
  defaultCashAccount: 'Cash Account',
  defaultExpenseClaimPayableAccount: 'Expense Claim Payable Account',
  profile: 'Profile',
  holidaylist: 'Holiday List',
  serviceUnit: 'Service Unit',
  companyName: 'Company Name',
  companyNameInArabic: 'Company Name In Arabic',
  abbr: 'Abbr',
  country: 'Country',
  dateOfEstablishment: 'Date Of Establishment',
  noOfMonthsOfExpense: 'No of Months of Expenses',
  cancelthePaymentEntry: 'Cancel the Payment Entry',
  AreyousuretoCancelthisPaymentEntry:
    'Are you sure to Cancel this Payment Entry?',
  CanceltheSalesInvoice: 'Cancel the Sales Invoice',
  AreyousuretoCancelthisSalesInvoice:
    'Are you sure to Cancel this Sales Invoice?',
  export: 'Export',
  canceltheEncounter: 'Cancel the Encounter',
  AreyousuretoCancelthisEncounter: 'Are you sure to Cancel this Encounter?',
  ledgerToGroup: 'Ledger To Group',
  groupForLedger: 'Group For Ledger',
  groupToLedger: 'Group To Ledger',
  EditAccountDetails: 'Edit Account Details',
  appointmentType: 'Appointment Type',
  inPatientVisit: 'Inpatient Visit Charge',
  TrialBalance: 'Trial Balance',
  appointment: 'Appointment',
  appointments: 'Appointments',
  Search: 'Search',
  editSupplierGroup: 'Edit Supplier Group',
  Cancel: 'Cancel',
  SupplierGroup: 'Supplier Group',
  ParentGroup: 'Parent Group',
  getPDF: 'Get PDF',
  addSupplierGroup: 'Add Supplier Group',
  CancelInvoice: 'Cancel Invoice',
  CancelPayment: 'Cancel Payment',
  Reset: 'Reset',
  totalDebit: 'Total Debit',
  StockEntry: 'Stock Entry',
  AddStockEntry: 'Add Stock Entry',
  totalAmount: 'Total Amount',
  SourceWarehouse: 'Source Warehouse',
  TargetWarehouse: 'Target Warehouse',
  stockEntryType: 'Stock Entry Type',
  totalCredit: 'Total Credit',
  baseAmount: 'Base Amount',
  AdditionalCosts: 'Additional Costs',
  toWarehouse: 'To Warehouse',
  totalIncomingValue: 'Total Incoming Value',
  fromWarehouse: 'From Warehouse',
  supplierType: 'Supplier Type',
  DeletetheSupplierGroup: 'Delete the Supplier Group',
  CreditInvoice: 'Credit Invoice',
  valueDifference: 'Value Difference',
  totalAdditionalCosts: 'Total Additional Costs',
  DeletetheStockEntry: 'Delete the Stock Entry',
  EditStockEntry: 'Edit Stock Entry',
  unallocated_amount: 'unallocated amount',
  total_allocated_amount: 'total allocated amount',
  differenceAmount: 'difference amount',
  DateOfBirth: 'Date Of Birth',
  totalIncomingValue: 'Total Incoming Value',
  totalOutgoingValue: 'Total Outgoing Value',
  patientAge: 'Patient Age',
  editPatient: 'Edit Patient',

  patientFileNumber: 'Patient File Number',
  searchAppointments: 'Search Appointments',
  requiredLastName: 'Please enter last name',
  requiredGender: 'Please enter gender',
  Phone: 'Phone',
  advancePaymentAccount: 'Advance Payment Account',
  companySettings: 'Company Settings',
  downPaymentItem: 'Down Payment Item',
  outPatientCharge: 'Out Patient Consulting Charge',
  addAppointment: 'Add Appointment',
  requiredEmail: 'Please enter email',
  requireIdentificationNumber: 'Please enter identification number',
  requiredPhoneNumber: 'Please enter phone number',
  requiredAddress: 'Please enter address',
  requiredOccupation: 'Please enter occupation',
  requiredCity: 'Please enter city',
  requiredAccountDetails: 'Please enter account details',
  requiredBloodGroup: 'Please enter blood group',
  requireCountry: 'Please enter country',
  requiredMobile: 'Please enter mobile',
  requiredImage: 'Please enter image',
  requiredInPatientVisit: 'Please enter in patient visit',
  requiredPrintLanguage: 'Please enter print language',
  requiredDate: 'Please enter date',
  requiredInPatientItem: 'Please enter in patient item',
  requiredOutPatient: 'Please enter out patient',
  requireMaritalStatus: 'Please enter marital status',
  requiredState: 'Please enter state',
  requiredDepartment: 'Please enter department',
  employmentType: 'Employment Type',
  requiredCountry: 'Please enter country',
  requiredAppointmentType: 'Please enter appointment type',
  requiredReports: 'Please enter reports',
  requiredOutPatientCharge: 'Please enter out patient charge',
  requiredPostalCode: 'Please enter postal code',
  requiredPatientFileNumber: 'Please enter patient file number',
  requiredPractitionerSchedule: 'Please enter practitioner schedule',
  requiredAppointmentTime: 'Please enter appointment time',
  requiredAppointmentDate: 'Please enter appointment date',
  requiredPractitionerName: 'Please enter practitioner name',
  requiredPractitionerNo: 'Please enter practitioner no',
  requiredMedicalDepartment: 'Please enter medical department',
  requiredStatus: 'Please enter status',
  requiredPatientName: 'Please enter patient name',
  requiredPatientAge: 'Please enter patient age',
  requiredPatientCareType: 'Please enter patient care type',
  requiredSymptoms: 'Please enter symptoms',
  requiredDiagnosis: 'Please enter diagnosis',
  requiredServiceUnit: 'Please enter service unit',
  requiredWarehouse: 'Please enter warehouse',
  requiredItemGroup: 'Please enter item group',
  requiredTestTemplate: 'Please enter test template',
  requiredEmployeeLab: 'Please enter employee lab',
  toDateGreaterThanFromDate: 'To date should be greater than from date',
};
